import * as React from "react";
import { Grid, Stack, Paper, Box, IconButton } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import TvIcon from "@mui/icons-material/Tv";
import { TutorialContext } from "../../../Utils/Helpers/tutorial";
import MediaCard from "../../../Components/Cards/MediaCard/media-card";
import AudioTrackMappingCard from "../../../Components/Cards/AudioTrackMappingCard";
import RequestCard from "../../../Components/Cards/RequestCard";
import SquareCard from "../../../Components/Cards/SquareCard";
import { useMultipleSelection } from "../../../Utils/Hooks/useMultipleSelection";
import ListItemCard from "../../../Components/Cards/ListItemCard";
import SelectableCard from "../../../Components/Cards/SelectableCard";
import ClipCard from "../../../Components/Cards/ClipCard/clip-card";
import CollectionCard from "../../../Components/Cards/CollectionCard";
import ConfigCard from "../../../Components/Cards/ConfigCard/config-card";
import ConfigOrderItemCard from "../../../Components/Cards/ConfigOrderItemCard/config-order-item-card";
import ContentCard from "../../../Components/Cards/ContentCard";
import ExpertiseCard from "../../../Components/Cards/ExpertiseCard";
import GenreCard from "../../../Components/Cards/GenreCard";
import MovieCard from "../../../Components/Cards/MovieCard/movie-card";
import OrderCard from "../../../Components/Cards/OrderCard/orderCard";
import OrderHorizontalCard from "../../../Components/Cards/OrderHorizontalCard";
import OrderHorizontalAdvancedCard from "../../../Components/Cards/OrderHorizontalAdvancedCard";
import OrderRecapCard from "../../../Components/Cards/OrderRecapCard/order-recap-config";
import ProductConfigCard from "../../../Components/Cards/ProductConfigCard/product-config-card";
import QCMarkerCard from "../../../Components/Cards/QCMarkerCard/qc-marker-card";
import TitleCollectionCard from "../../../Components/Cards/TitleCollectionCard/title-collection-card";
import UploadCard, { UploadContext } from "../../../Components/Cards/UploadCard/upload-card";
import WishlistCollectionCard from "../../../Components/Cards/WishlistCollectionCard/wishlist-collection-card";
import WishlistAddToCollectionCard from "../../../Components/Cards/WishlistAddToCollectionCard";
import TitleCard from "../../../Components/Cards/TitleCard";
import ConfigTaskCard from "../../../Components/Cards/ConfigTaskCard/stack-task-card";
import DemoFigmaTitle from "../../../Components/Demo/DemoFigmaTitle";
import ContractDetailsCard from "../../../Components/Cards/ContractDetailsCard/contract-details-card";
import ProviderRequestCard from "../../../Components/Cards/ProviderRequestCard";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import { OrderStatus } from "../../../Core/Api/Types/order-status";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { ObjectStatus } from "../../../Core/Api/Types/object-status";
import { DbMarkerSeverity } from "../../../Core/Api/Types/db-marker-severity";
import { DbMarkerCategory } from "../../../Core/Api/Types/db-marker-category";
import { FileStatus } from "../../../Core/Api/Types/file-status";
import { StackTaskType } from "../../../Core/Api/Types/stack-task-type";
import { StackTaskKind } from "../../../Core/Api/Types/stack-task-kind";
import moment from "moment";
import { DbOrderItemInfos } from "../../../Core/Api/Types/db-order-item-infos";
import { useTranslation } from "react-i18next";

function DemoCards() {
  const { t } = useTranslation();
  const tutorialContext = React.useContext(TutorialContext);
  const { setTutorialPage } = { ...tutorialContext };
  const { isSelected: isSquareCardSelected, select: selectSquareCard } = useMultipleSelection();

  React.useEffect(() => {
    if (!setTutorialPage) {
      return;
    }

    setTutorialPage("demo");
  }, [setTutorialPage]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, backgroundImage: "none" }}>
            <Grid container spacing={4}>
              <Grid item md={6}>
                <h1 id="list-item-card">{t("page:body.listItemCard")}</h1>
                <Box>
                  <ListItemCard>
                    Card Liste{" "}
                    <IconButton>
                      <WarningIcon fontSize="small" />
                    </IconButton>
                  </ListItemCard>
                  <ListItemCard>
                    Card Liste{" "}
                    <IconButton>
                      <WarningIcon fontSize="small" />
                    </IconButton>
                  </ListItemCard>
                  <ListItemCard>
                    Card Liste{" "}
                    <IconButton>
                      <WarningIcon fontSize="small" />
                    </IconButton>
                  </ListItemCard>
                </Box>
                <Box sx={{ mt: 4 }}>
                  <ListItemCard>
                    Card Liste{" "}
                    <IconButton>
                      <WarningIcon fontSize="small" />
                    </IconButton>
                  </ListItemCard>
                </Box>
                <Box sx={{ mt: 4 }}>
                  <ListItemCard>Card Liste</ListItemCard>
                </Box>
              </Grid>
              <Grid item md={6}>
                <h1 id="selectable-card">{t("page:body.selectableCard")}</h1>
                <SelectableCard onClick={() => false}>{t("common:unselected")}</SelectableCard>
                <SelectableCard onClick={() => false} selected>
                  {t("common:selected")}
                </SelectableCard>
                <SelectableCard onClick={() => false} selected hideCheckbox>
                  {t("page:selectableCard.body.hideCheckbox")}
                </SelectableCard>
              </Grid>
              <Grid item md={3}>
                <h1 id="content-card">{t("page:body.contentCard")}</h1>
                <Box>
                  <ContentCard
                    type="trailer"
                    title={`${t("page:body.contentCard")} - ${t("common:trailer")}`}
                    audioList={["audio1"]}
                    subtitleList={["subtitle1", "subtitle2"]}
                    qualityList={["quality1", "quality2"]}
                    formatList={["format1", "format2"]}
                  />
                </Box>
              </Grid>
              <Grid item md={3}>
                <h1 id="collection-card">{t("common:collectionCard")}</h1>
                <CollectionCard
                  sx={{ mb: 2 }}
                  to=""
                  title={`${t("page:collectionCard.title.collectionCardTitle")} - ${t(
                    "page:collectionCard.title.cover"
                  )}`}
                  covers={["/static/images/temp/movie-cover-2.jpg"]}
                />
                <CollectionCard
                  sx={{ mb: 2 }}
                  to=""
                  title={`${t("page:collectionCard.title.collectionCardTitle")} - ${t("common:placeholderUpperCase")}`}
                  placeholder
                />
              </Grid>
              <Grid item md={6}>
                <h1 id="genre-card"> {t("page:body.genreCard")}</h1>
                <Stack spacing={2}>
                  <GenreCard
                    to=""
                    title={`${t("page:collectionCard.title.collectionCardTitle")} - ${t(
                      "page:collectionCard.title.cover"
                    )}`}
                    subtitle={t("page:genreCard.subtitle.contentsWithCount", { count: 30 })}
                    cover="/static/images/temp/genre-card-thrillers.jpg"
                  />
                  <GenreCard
                    to=""
                    title={`${t("page:collectionCard.title.collectionCardTitle")} - ${t(
                      "page:collectionCard.title.cover"
                    )}`}
                    subtitle={t("page:genreCard.subtitle.contentsWithCount", { count: 30 })}
                    cover="/static/images/temp/genre-card-animation.jpg"
                  />
                </Stack>
              </Grid>
              <Grid item md={3}>
                <h1 id="movie-card">
                  {t("page:body.movieCard")}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("common:title")} / ${t(
                    "route:pageTitle.catalog"
                  )}`}</DemoFigmaTitle>
                </h1>
                <Box width={180}>
                  <MovieCard
                    id={0}
                    cover="/static/images/temp/movie-cover-1.jpg"
                    title={t("page:movieCard.title.movieCardTitle")}
                    labelList={["new", "top", "premium"]}
                    transparentChipText="Quality"
                    favorite={true}
                    expand={{
                      tagList: ["Tag 1", "Tag 2"],
                      contentList: ["Content 1", "Content 2"],
                      audioList: ["Audio 1", "Audio 2"],
                      subtitleList: ["Subtitle 1", "Subtitle 2"],
                      quality: "Quality",
                    }}
                  />
                </Box>
              </Grid>

              <Grid item md={3}>
                <h1 id="wishlist-collection-card">
                  {t("page:body.wishlistCollectionCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("common:collection")}`}</DemoFigmaTitle>
                </h1>
                <Box width={250}>
                  <WishlistCollectionCard
                    id={0}
                    covers={[
                      "/static/images/temp/movie-cover-1.jpg",
                      "/static/images/temp/movie-cover-2.jpg",
                      "/static/images/temp/movie-cover-3.jpg",
                      "/static/images/temp/movie-cover-4.jpg",
                    ]}
                    nbTitles={130}
                    nbTotaleItem={130}
                    title={`${t("common:collectionCard")} - ${t("common:title")}`}
                  />
                </Box>
              </Grid>
              <Grid item md={6}>
                <h1 id="expertise-card">{t("page:body.expertiseCard")}</h1>
                <Box>
                  <ExpertiseCard
                    title={t("page:expertiseCard.title.expertiseCardTitle")}
                    desc="Adipisicing ea elit dolor cupidatat id dolor tempor."
                    progressValue={60}
                    icon={<TvIcon />}
                  />
                </Box>
              </Grid>
              <Grid item md={6}>
                <h1 id="square-card">
                  {t("page:body.squareCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("common:storefront")}`}</DemoFigmaTitle>
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("common:pack")}`}</DemoFigmaTitle>
                </h1>
                <Box width={180}>
                  <SquareCard
                    id={1}
                    to=""
                    onCheckboxClick={(id) => {
                      selectSquareCard(id);
                    }}
                    onEditClick={(id) => {
                      console.log(`Edit card : ${id}`);
                    }}
                    onDeleteClick={(id) => {
                      console.log(`Delete card : ${id}`);
                    }}
                    selected={isSquareCardSelected("pack-card")}
                    title={t("page:squareCard.title.internationalVersion")}
                    subtitle={t("field:placeholder.subtitle")}
                  />
                </Box>
              </Grid>
              <Grid item md={6}>
                <h1 id="product-config-card">
                  {t("page:body.productConfigCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:config")} / ${t("page:body.productTile")}`}</DemoFigmaTitle>
                </h1>
                <Box height={120} width={240}>
                  <ProductConfigCard
                    title={t("page:productConfigCard.title.packageBundle")}
                    id={0}
                    type={OrderProductType.TranscodeByProfile}
                    selected={false}
                    onClickCard={() => false}
                  />
                </Box>
              </Grid>
              <Grid item md={6}>
                <h1 id="title-card">
                  {t("page:body.titleCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("common:title")} / ${t(
                    "page:body.interactiveCard"
                  )}`}</DemoFigmaTitle>
                </h1>
                <TitleCard
                  poster="/static/images/temp/movie-cover-1.jpg"
                  title="Blade Runner 2049"
                  titleId={0}
                  subtitle={t("common:trailer")}
                  price="130€"
                />
              </Grid>
              <Grid item md={6}>
                <h1 id="whishlist-add-to-collection-card">{t("page:body.wishlistAddToCollectionCard")}</h1>
                <WishlistAddToCollectionCard
                  id={0}
                  covers={[
                    "/static/images/temp/movie-cover-1.jpg",
                    "/static/images/temp/movie-cover-2.jpg",
                    "/static/images/temp/movie-cover-3.jpg",
                    "/static/images/temp/movie-cover-4.jpg",
                  ]}
                  fixedWidth={50}
                  nbTitles={80}
                  nbTotaleItem={80}
                  title={`${t("common:collectionCard")} - ${t("common:title")}`}
                  small
                  direction="row"
                  isDeletable
                />
              </Grid>
              <Grid item md={6}>
                <h1 id="request-card">{t("page:body.requestCard")}</h1>
                <RequestCard
                  sx={{ mb: 2 }}
                  id="blade-runner"
                  cover="/static/images/temp/movie-cover-1.jpg"
                  title="Blade Runner 2049"
                  contents={[
                    { name: "Trailer", id: 1, childCount: 2 },
                    { name: "Feature - long", id: 2, childCount: 5 },
                    { name: "Bonuses", id: 3, childCount: 7 },
                    { name: `Feature - director's cut`, id: 4, childCount: 0 },
                    { name: "Feature - basic", id: 5, childCount: 4 },
                  ]}
                />
                <RequestCard
                  alreadyAddedToRequest
                  id="blade-runner"
                  cover="/static/images/temp/movie-cover-1.jpg"
                  title="Blade Runner 2049"
                  contents={[
                    { name: "Trailer", id: 1, childCount: 0 },
                    { name: "Feature - long", id: 2, childCount: 4 },
                    { name: "Bonuses", id: 3, childCount: 6 },
                    { name: `Feature - director's cut`, id: 4, childCount: 8 },
                    { name: "Feature - basic", id: 5, childCount: 3 },
                  ]}
                />
              </Grid>

              <Grid item md={6}>
                <h1 id="title-collection-card">{t("page:body.titleCollectionCard")}</h1>
                <TitleCollectionCard
                  sx={{ mb: 2 }}
                  poster="/static/images/temp/movie-cover-1.jpg"
                  title={t("page:movieCard.title.movieCardTitle")}
                  desc={t("common:trailer")}
                  onClickAdd={() => false}
                  onClickRemove={() => false}
                  status="added"
                />
                <TitleCollectionCard
                  sx={{ mb: 2 }}
                  poster="/static/images/temp/movie-cover-1.jpg"
                  title={t("page:movieCard.title.movieCardTitle")}
                  desc={t("common:trailer")}
                  onClickAdd={() => false}
                  onClickRemove={() => false}
                  status="just-added"
                />
                <TitleCollectionCard
                  sx={{ mb: 2 }}
                  poster="/static/images/temp/movie-cover-1.jpg"
                  title={t("page:movieCard.title.movieCardTitle")}
                  desc={t("common:trailer")}
                  onClickAdd={() => false}
                  onClickRemove={() => false}
                  status="none"
                />
              </Grid>

              <Grid item md={6}>
                <h1 id="media-card">
                  {t("page:body.mediaCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("route:pageTitle.inventory")} / ${t(
                    "page:body.mediaFile"
                  )}`}</DemoFigmaTitle>
                </h1>
                <MediaCard
                  fileId={0}
                  isDownloable={false}
                  downloadLink=""
                  title="ProxyTag_34724.mp4"
                  type={ObjectType.Video}
                  status={FileStatus.Online}
                  duration="00:06:28:22"
                  storageLocation="[DR-SC] Video Proxy 01"
                  category="FREE TV CABLE"
                  accessibility="DiskAndTape"
                  size="102.265 MB"
                  date="29/04/21"
                />
              </Grid>
              <Grid item md={6}>
                <h1 id="audio-track-mapping-card">
                  {" "}
                  {t("page:body.audioTrackMappingCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:cards")} / ${t("route:pageTitle.inventory")} / ${t(
                    "page:body.audioTrack"
                  )}`}</DemoFigmaTitle>
                </h1>

                {/* <AudioTrackMappingCard
                  id={1}
                  version="ov"
                  versionOptions={[{ value: "ov", display: "OV" }]}
                  language="eng"
                  languageOptions={[
                    { value: "eng", display: "ENG" },
                    { value: "fra", display: "FRA" },
                  ]}
                  position="lt"
                  positionOptions={[{ value: "lt", display: "Lt" }]}
                  sampling="48000"
                  bitDepth="24"
                  format="pcm"
                  formatOptions={[{ value: "pcm", display: "PCM" }]}
                  r128={false}
                  dolbyE={false}
                  onEditing={(newValues) => {
                    console.log(newValues);
                  }}
                /> */}
              </Grid>
              <Grid item md={6}>
                <h1 id="config-task-card">
                  {t("page:body.configTaskCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("common:config")} / ${t("common:task")}`}</DemoFigmaTitle>
                </h1>
                <ConfigTaskCard
                  title={t("page:configTaskCard.title.restoreSmsm")}
                  taskType={StackTaskType.Job}
                  taskKind={StackTaskKind.FileTranscode}
                  ressourceId={156840}
                  startDate={moment().toDate()}
                  endDate={moment().toDate()}
                  infos="Hsm > Restore Snsm"
                  status={OrderStatus.READY}
                  progress={100}
                />
                <ConfigTaskCard
                  title={t("page:configTaskCard.title.restoreSmsm")}
                  taskType={StackTaskType.Job}
                  taskKind={StackTaskKind.FileTranscode}
                  ressourceId={156840}
                  startDate={moment().toDate()}
                  endDate={moment().toDate()}
                  infos="Hsm > Restore Snsm"
                  status={OrderStatus.FAILED}
                  progress={100}
                />
                <ConfigTaskCard
                  title={t("page:configTaskCard.title.restoreSmsm")}
                  taskType={StackTaskType.Job}
                  taskKind={StackTaskKind.FileTranscode}
                  ressourceId={156840}
                  startDate={moment().toDate()}
                  endDate={moment().toDate()}
                  infos="Hsm > Restore Snsm"
                  status={OrderStatus.COMPLETED}
                  progress={100}
                />
              </Grid>
              <Grid item md={6}>
                <h1 id="contract-details-card">
                  {t("page:body.contractDetailsCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("route:pageTitle.contracts")} / ${t(
                    "page:body.contractDetails"
                  )}`}</DemoFigmaTitle>
                </h1>
                <h2>{t("common:large")}</h2>
                <ContractDetailsCard
                  contractId={118668}
                  contractTitle="Matrix"
                  customerName="TVF200102"
                  broadcaster="416403"
                  mediaName="FREE TV CABLE"
                  id="TVF200102"
                  workId="416403"
                  externalId="#12563"
                  startDate="26/07/22"
                  endDate="26/07/22"
                  rightType="Disposal"
                  languages={["Fr", "En", "Deu", "Es", "It"]}
                  territories={["Andora", "France", "GuianaFrench", "GuianaFrench2", "Polynesia", "Other", "Other"]}
                />
                <h2>{t("common:small")}</h2>
                <ContractDetailsCard
                  contractId={118668}
                  contractTitle="Matrix"
                  customerName="TVF200102"
                  broadcaster="416403"
                  mediaName="FREE TV CABLE"
                  id="TVF200102"
                  workId="416403"
                  externalId="#12563"
                  startDate="26/07/22"
                  endDate="26/07/22"
                  rightType="Disposal"
                  languages={["Fr", "En", "Deu", "Es", "It"]}
                  territories={["Andora", "France", "GuianaFrench", "GuianaFrench2", "Polynesia", "Other", "Other"]}
                  small
                />
              </Grid>
              <Grid item md={6}>
                <h1 id="provider-request-card">{t("page:body.providerRequestCard")}</h1>
                <ProviderRequestCard
                  title={`${t("common:totalRecall")} / ${t("common:bonus")}`}
                  desc="DREAMERS WITHIN THE DREAM : LA GENÈSE DE TOTAL RECALL / Mezz - French - Full Subtitles - STL - Open - 24fps"
                  startDate="11/06/19, 17:17:01"
                  endDate="09/01/21, 05:32:08"
                  status="auto-rejected"
                  comments={2}
                  assetType={ObjectType.Audio}
                />
                <ProviderRequestCard
                  title={`t("common:totalRecall")} / ${t("common:bonus")}`}
                  desc="DREAMERS WITHIN THE DREAM : LA GENÈSE DE TOTAL RECALL / Mezz - French - Full Subtitles - STL - Open - 24fps"
                  startDate="11/06/19, 17:17:01"
                  endDate="09/01/21, 05:32:08"
                  status="accepted"
                  comments={2}
                  assetType={ObjectType.Video /*TODO : Was trailer => find new equivalent*/}
                />
              </Grid>
              <Grid item md={6}>
                <h1 id="qc-marker-card">
                  {t("page:body.qcMarkerCard")}{" "}
                  <DemoFigmaTitle>{`${t("page:body.mediaPlayer")} / ${t("page:body.console")} / ${t(
                    "page:body.qcMarker"
                  )}`}</DemoFigmaTitle>
                </h1>
                <Stack spacing={3}>
                  <QCMarkerCard
                    id={-500}
                    title={t("page:qcMarkerCard.title.qcMarkerCard")}
                    subtitle={t("field:placeholder.subtitle")}
                    desc="Officia reprehenderit magna irure adipisicing ullamco."
                    timecodes={{
                      in: { markFrame: 10 * 60 * 25 + 5 * 25, isSet: true },
                      out: { markFrame: 12 * 60 * 25 + 20 * 25, isSet: true },
                      frameRate: 25,
                    }}
                    status={DbMarkerSeverity.ERROR}
                    tag={DbMarkerCategory.Human}
                  />
                </Stack>
              </Grid>
              <Grid item md={6}>
                <h1 id="clip-card">{t("page:body.clipCard")}</h1>
                <ClipCard
                  id={-500}
                  clipName={t("page:clipCard.title.clipCardTitle")}
                  timecodes={{
                    in: { markFrame: 12 * 25, isSet: true },
                    out: { markFrame: 15 * 25, isSet: true },
                  }}
                  createdBy="Author name"
                  createdAt={new Date("20/12/2022").toDateString()}
                />

                {/* <ClipCard
                  sx={{ mb: 2 }}
                  title="Clip card Title - Selectable"
                  timecodes={{ start: "00:00:12", end: "00:00:15" }}
                  createdBy="Author name"
                  createdAt={{ date: "20/12/2022", time: "" }}
                  selectable
                />
                <ClipCard
                  sx={{ mb: 2 }}
                  title="Clip card Title - Expandable"
                  timecodes={{ start: "00:00:12", end: "00:00:15" }}
                  createdBy="Author name"
                  createdAt={{ date: "20/12/2022", time: "00:00:03" }}
                  expandable
                  playable
                />
                <ClipCard
                  sx={{ mb: 2 }}
                  title="Clip card Title - Expandable : Expanded"
                  timecodes={{ start: "00:00:12", end: "00:00:15" }}
                  createdBy="Author name"
                  createdAt={{ date: "20/12/2022", time: "00:00:03" }}
                  expandable
                  isExpanded
                  playable
                /> */}
              </Grid>
              <Grid item md={6}>
                <h1 id="upload-card">
                  {t("page:body.uploadCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:card")} / ${t("page:body.uploadImage")}`}</DemoFigmaTitle>
                </h1>
                <Stack spacing={2}>
                  <UploadCard
                    title={t("card:title.uploadYourFile")}
                    name="upload-card-1"
                    userHasRightToDelete={true}
                    objectId={0}
                    format={{
                      id: 1,
                      isUploaded: false,
                      maxFileSizeMb: 100,
                      name: "example format",
                      userHasRighToDelete: false,
                      acceptsFiles: { ["application/octet-stream"]: ["pdf"] },
                      description: t("page:uploadCard.description.exampleDescription"),
                      isUserDataMandatory: false,
                      objectType: ObjectType.Image,
                    }}
                    context={UploadContext.MediaFile}
                  />

                  <UploadCard
                    title={t("common:assetUpperCase")}
                    coverRounded
                    coverPlaceholderIcon={<AccountCircleOutlinedIcon />}
                    name="upload-card-2"
                    userHasRightToDelete={true}
                    objectId={0}
                    format={{
                      id: 1,
                      isUploaded: false,
                      maxFileSizeMb: 100,
                      name: "example format",
                      userHasRighToDelete: false,
                      acceptsFiles: { ["application/octet-stream"]: ["pdf"] },
                      description: t("page:uploadCard.description.exampleDescription"),
                      isUserDataMandatory: false,
                      objectType: ObjectType.Image,
                    }}
                    context={UploadContext.MediaFile}
                  />
                  <UploadCard
                    title={t("page:uploadCard.title.uploadingCard")}
                    resolution="250x500"
                    ratio="1:3"
                    coverPlaceholderIcon={<AccountCircleOutlinedIcon />}
                    name="upload-card-3"
                    userHasRightToDelete={true}
                    objectId={0}
                    format={{
                      id: 1,
                      isUploaded: false,
                      maxFileSizeMb: 100,
                      name: "example format",
                      userHasRighToDelete: false,
                      acceptsFiles: { ["application/octet-stream"]: ["pdf"] },
                      description: t("page:uploadCard.description.exampleDescription"),
                      isUserDataMandatory: false,
                      objectType: ObjectType.Image,
                    }}
                    context={UploadContext.MediaFile}
                  />
                  <UploadCard
                    cover="/static/images/temp/movie-cover-1.jpg"
                    title="Picture.png"
                    resolution="250x500"
                    ratio="1:3"
                    name="upload-card-4"
                    userHasRightToDelete={true}
                    objectId={0}
                    format={{
                      id: 1,
                      isUploaded: false,
                      maxFileSizeMb: 100,
                      name: "example format",
                      userHasRighToDelete: false,
                      acceptsFiles: { ["application/octet-stream"]: ["pdf"] },
                      description: t("page:uploadCard.description.exampleDescription"),
                      isUserDataMandatory: false,
                      objectType: ObjectType.Image,
                    }}
                    context={UploadContext.MediaFile}
                  />
                  <UploadCard
                    title={t("card:title.uploadYourFile")}
                    small
                    name="upload-card-5"
                    userHasRightToDelete={true}
                    objectId={0}
                    format={{
                      id: 1,
                      isUploaded: false,
                      maxFileSizeMb: 100,
                      name: "example format",
                      userHasRighToDelete: false,
                      acceptsFiles: { ["application/octet-stream"]: ["pdf"] },
                      description: t("page:uploadCard.description.exampleDescription"),
                      isUserDataMandatory: false,
                      objectType: ObjectType.Image,
                    }}
                    context={UploadContext.MediaFile}
                  />
                  <UploadCard
                    title={t("page:uploadCard.title.uploadingCard")}
                    //desc="Optional Description"
                    small
                    name="upload-card-6"
                    userHasRightToDelete={true}
                    objectId={0}
                    format={{
                      id: 1,
                      isUploaded: false,
                      maxFileSizeMb: 100,
                      name: "example format",
                      userHasRighToDelete: false,
                      acceptsFiles: { ["application/octet-stream"]: ["pdf"] },
                      description: t("page:uploadCard.description.exampleDescription"),
                      isUserDataMandatory: false,
                      objectType: ObjectType.Image,
                    }}
                    context={UploadContext.MediaFile}
                  />
                  <UploadCard
                    cover="/static/images/temp/movie-cover-1.jpg"
                    title="File.mp3"
                    resolution="250x500"
                    ratio="1:3"
                    //desc="37Mo"
                    small
                    objectId={0}
                    format={{
                      id: 1,
                      isUploaded: false,
                      maxFileSizeMb: 100,
                      name: "example format",
                      userHasRighToDelete: false,
                      acceptsFiles: { ["application/octet-stream"]: ["pdf"] },
                      description: t("page:uploadCard.description.exampleDescription"),
                      isUserDataMandatory: false,
                      objectType: ObjectType.Image,
                    }}
                    name="upload-card-7"
                    userHasRightToDelete={true}
                    context={UploadContext.MediaFile}
                  />
                </Stack>
              </Grid>
              <Grid item md={6}>
                <h1 id="config-card">
                  {t("page:body.configCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:config")} / ${t("common:customers")} / ${t(
                    "page:body.configTile"
                  )}`}</DemoFigmaTitle>
                </h1>
                <ConfigCard
                  sx={{ mb: 2 }}
                  title={t("page:configCard.title.configCardTitle")}
                  status="complete"
                  helperText={t("page:configCard.helperText.helperText")}
                  content={{
                    quality: "Quality",
                    voice: "Voice",
                    collection: "Collection",
                    subtitles: t("common:subtitles"),
                    transfert: "Transfert",
                  }}
                  forms={[]}
                  expanded={false}
                  onExpand={() => {}}
                  configType="self-broadcasted"
                />
                <ConfigCard
                  sx={{ mb: 2 }}
                  title={t("page:configCard.title.configCardTitle")}
                  status="complete"
                  helperText={t("page:configCard.helperText.helperText")}
                  content={{
                    quality: "Quality",
                    voice: "Voice",
                    collection: "Collection",
                    subtitles: t("common:subtitles"),
                    transfert: "Transfert",
                  }}
                  forms={[]}
                  expanded
                  onExpand={() => {}}
                  configType="self-broadcasted"
                />
              </Grid>
              <Grid item md={12}>
                <h1 id="config-orde-item-card">
                  {t("page:body.configOrderItemCard")}{" "}
                  <DemoFigmaTitle>{`${t("common:config")} / ${t("common:customers")} / ${t(
                    "page:body.titleTile"
                  )}`}</DemoFigmaTitle>
                  <DemoFigmaTitle>{`${t("common:config")} / ${t("common:customers")} / ${t(
                    "page:body.contentRow"
                  )}`}</DemoFigmaTitle>
                </h1>
                <Stack spacing={2}></Stack>
              </Grid>
              <Grid item xs={12}>
                <h1 id="order-card">{t("page:body.orderCards")}</h1>
                <Grid container spacing={3}>
                  <Grid item md={6}>
                    <h2 id="order-card-default">
                      {t("page:body.orderCard")}{" "}
                      <DemoFigmaTitle>{`${t("common:card")} / ${t("common:config")} / ${t("common:item")} / ${t(
                        "page:body.simpleVertical"
                      )}`}</DemoFigmaTitle>
                    </h2>
                    <OrderCard
                      title="Blade Runner 2059"
                      subtitle={t("common:trailer")}
                      thumbnail="/static/images/temp/movie-cover-2.jpg"
                      index={0}
                      item={new DbOrderItemInfos()}
                      config={{
                        title: t("common:selfBroadcastedFileToOcs"),
                        type: OrderProductType.TranscodeByProfile,
                        price: "130€",
                        content: { setting: "4K HDR", voice: "Voice" },
                        attachement: "Attachement.jpg",
                        status: OrderStatus.RUNNING,
                        activities: 1,
                      }}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <h2 id="order-horizontal-card">
                      {t("page:body.orderHorizontalCard")}{" "}
                      <DemoFigmaTitle>{`${t("common:card")} / ${t("common:config")} / ${t("common:item")} / ${t(
                        "page:body.simpleHorizontal"
                      )}`}</DemoFigmaTitle>
                    </h2>
                    <OrderHorizontalCard
                      title="Blade Runner 2059"
                      titleId={0}
                      subtitle={t("common:trailer")}
                      thumbnail="/static/images/temp/movie-cover-2.jpg"
                      config={{
                        title: t("common:selfBroadcastedFileToOcs"),
                        configType: OrderProductType.TranscodeByProfile,
                        price: "130€",
                        content: { setting: "4K HDR", voice: "Voice" },
                        attachement: "Attachement.jpg",
                      }}
                      status={OrderStatus.RUNNING}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <h2 id="order-horizontal-advanced-card">
                      {t("page:body.orderHorizontalAdvancedCard")}{" "}
                      <DemoFigmaTitle>{`${t("common:card")} / ${t("common:config")} / ${t("common:item")} / ${t(
                        "page:body.advanced"
                      )}`}</DemoFigmaTitle>
                    </h2>
                    <OrderHorizontalAdvancedCard
                      title="Blade Runner 2059"
                      titleId={0}
                      itemId={78755}
                      subtitle={t("common:trailer")}
                      thumbnail="/static/images/temp/movie-cover-2.jpg"
                      priority="high"
                      config={{
                        title: t("common:selfBroadcastedFileToOcs"),
                        configType: OrderProductType.TranscodeByProfile,
                        price: "130€",
                        content: { setting: "4K HDR", voice: "Voice" },
                        attachement: "Attachement.jpg",
                      }}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <h2 id="order-recap-card">{t("page:body.orderRecapCard")}</h2>
                    {/*<Stack spacing={2}>
                      <OrderRecapCard
                        title="Order Recap Card Title"
                        contractId={123456}
                        price="130€"
                        thumbnail="/static/images/temp/movie-cover-2.jpg"
                        list={[
                          {
                            id: 0,
                            title: "Trailer",
                            price: "130€",
                            configs: [
                              {
                                id: 0,
                                configType: "vod",
                                title: "Vod Package",
                                price: "75€",
                                content: { setting: "Quality", voice: "Voice" },
                                attachement: "Attachement.jpg",
                              },
                              {
                                id: 1,
                                configType: "self-broadcasted",
                                title: "Self-broadcasted file to OCS",
                                price: "75€",
                                content: { setting: "Quality", voice: "Voice" },
                                attachement: "Attachement.jpg",
                              },
                            ],
                          },
                        ]}
                      />
                      <OrderRecapCard
                        title="Order Recap Card Title (Provider)"
                        contractId={123456}
                        price="130€"
                        thumbnail="/static/images/temp/movie-cover-2.jpg"
                        list={[
                          {
                            id: 0,
                            title: "Trailer",
                            price: "130€",
                            missingAssets: 5,
                            configs: [
                              {
                                id: 0,
                                configType: "vod",
                                title: "Vod Package",
                                price: "75€",
                                content: { setting: "Quality", voice: "Voice" },
                                attachement: "Attachement.jpg",
                              },
                              {
                                id: 1,
                                configType: "self-broadcasted",
                                title: "Self-broadcasted file to OCS",
                                price: "75€",
                                content: { setting: "Quality", voice: "Voice" },
                                attachement: "Attachement.jpg",
                              },
                            ],
                          },
                          {
                            id: 1,
                            title: "Trailer 2",
                            price: "130€",
                            doable: true,
                            configs: [
                              {
                                id: 0,
                                configType: "vod",
                                title: "Vod Package",
                                price: "75€",
                                content: { setting: "Quality", voice: "Voice" },
                                attachement: "Attachement.jpg",
                              },
                              {
                                id: 1,
                                configType: "self-broadcasted",
                                title: "Self-broadcasted file to OCS",
                                price: "75€",
                                content: { setting: "Quality", voice: "Voice" },
                                attachement: "Attachement.jpg",
                              },
                            ],
                          },
                        ]}
                      />
                    </Stack>*/}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default DemoCards;
